import React, { useState, useEffect,  useCallback, useRef } from 'react'
import { logger } from '../../utils/logger'
import {Form, Button, DropdownButton, Dropdown, ProgressBar, Offcanvas, Modal} from "react-bootstrap";
import axios from 'axios';
import * as signalR from "@microsoft/signalr";
import { Container } from 'reactstrap';
import '../account/Drones.css';
import Modem from '../account/Modem';
import ConsoleBindCard from './ConsoleBindCard';
import Bind from '../account/Bind';
import SortCard from '../account/SortCard';
import ConsoleNavMenu from './ConsoleNavMenu';
import ModemCard from './ModemCard';
import ConsoleBind from './ConsoleBind';
import './Console.css';
import ConsoleMap from './ConsoleMap';
import StatusText from './StatusText';
import Account from './Account';
import NavigationData from './NavigationData';
import ModemSettings from './ModemSettings'
import UserSettings from './UserSettings';
import { createImmediatelyInvokedFunctionExpression } from 'typescript';
import WebRtc from './webRtc/WebRtc';
import AstraWelcome from './astra/AstraWelcome'
import Fpv from './fpv/Fpv';
import FpvModeButton from './fpv/FpvModeButton';
import SubscriptionNotification from './astra/SubscriptionNotification';



function Console(){
    const protocol = new signalR.JsonHubProtocol();
    const transport = signalR.HttpTransportType.WebSockets;

    const [mode, setMode] = useState("normal");

    const [drone, setDrone] = useState(null);
    const [mapFocusOnDrone, setMapFocusOnDrone] = useState(null);
    const [drones, setDrones] = useState([]);
    const [isOnline, setIsOnline] = useState(false);
    const [isConfirmEmail, setIsConfirmEmail] = useState(false)
    const [isNebosvodAuth, setIsNebosvodAuth] = useState(false)
    const [nebosvodAuthLogin, setNebosvodLogin] = useState("")
    const [startMsgs, setStartMsgs] = useState([]);

    const [isLoad, setIsLoad] = useState(false);
    const [isBind, setIsBind] = useState(false);
    const [modemCardOnlineTop, setModemCardOnlineTop] = useState(false);

    const [updateOnlineDroneFromHub, setUpdateDroneFromHub] = useState(null);
    const [updateHbFromHub, setUpdateHbFromHub] = useState(null);

    const [showMsgs, setShowMsgs] = useState(false);

    const [showMenu, setShowMenu] = useState(false);
    const handleCloseMenu = useCallback(() => {setShowMenu(false); logger.info("handle close menu")}, []);
    const toggleShowMenu = useCallback(() => {setShowMenu((s) => !s); logger.info("show menu:"); logger.info(showMenu);}, []);

    const consoleNavMsgClick = useCallback(() => {setShowMsgs((s) => !s)}, []);


    const [hubTest, setHubTest] = useState(hubConnect);

    const modemCardRefs = useRef({});

    const [isAstra, setIsAstra] = useState(process.env.REACT_APP_SERVICE == 'astra');

    const [showFpvModal, setShowFpvModel] = useState(false);
    const [subscriptions, setSubscriptions] = useState([]);

    useEffect(() => {
        logger.info("console mount");
        getDronesInfo();
        getSubscriptions();
    }, []);

    useEffect(() => {
        if(updateOnlineDroneFromHub != null){
            var ddd = drones.map(d => 
                {
                    var temp = Object.assign({}, d);
                    if(updateOnlineDroneFromHub.imei === temp.imei){
                        temp.isOnline = updateOnlineDroneFromHub.isOnline
                    }
                    return temp;
                }
            );
            //logger.info(ddd);
            setDrones(ddd);
        } 
    }, [updateOnlineDroneFromHub]);

    useEffect(() => {
        if(drones.length > 8){
            setModemCardOnlineTop(true);
        }
    }, [drones]);

    useEffect(() => {
        if(updateHbFromHub != null){
            var update = false;
            var ddd = drones.map(d => 
                {
                    
                    var temp = Object.assign({}, d);
                    if(updateHbFromHub.imei === temp.imei){
                        if(updateHbFromHub.isArm != temp.isArm)
                        {
                            //todo: refresh only arm
                            update = true;
                        }
                        temp.isArm = updateHbFromHub.isArm;
                        temp.mode = updateHbFromHub.mode;
                    }
                    /*if(drone?.imei === temp.imei) {
                        setDrone(temp);
                        logger.info('Set drone tmp:')
                        logger.info(temp);
                    }*/
                    return temp;
                }
            );
            //logger.info(ddd);
            if(update === true) {
                setDrones(ddd);
            }
        } 
    }, [updateHbFromHub]);

    useEffect(() => {
        return () => {
            logger.info("drone.js unmount");
            hubTest.stop();
        };
    }, []);

    function getDronesInfo(){
        axios.get('api/drone/getModems')
        .then(response => {
            logger.info("drone:"); 
            logger.info(response.data);
            setDrones(response.data.modemsInfo);
            setIsConfirmEmail(response.data.isConfirmEmail)
            setIsNebosvodAuth(response.data.isNebosvodAuth)
            setNebosvodLogin(response.data.nebosvodLogin)
            setStartMsgs(response.data.startMsgs)
            setIsLoad(true);
        })
        .catch(ex => {
            logger.info(ex);
            if(ex.response.status === 401) {
                window.location = "/login";
            }
        });
    }

    function getSubscriptions(){
        axios.get('/api/astraSubscription/getSubscriptions')
            .then(response => {
                setSubscriptions(response.data);
            });
    }

    function hubConnect(){
        let connection = new signalR.HubConnectionBuilder()
            .withUrl("api/drone-hub")
            .withAutomaticReconnect([0, 2000, 10000, 10000, 30000, 10000])
            .withHubProtocol(protocol)
            .build();;
        connection.on('SetOnline', (message) => 
        {
            //logger.info("hub: SetOnline"); 
            setUpdateDroneFromHub(message);
        });

        connection.on('HbStatus', (message) =>
        {
            //logger.info("hub: HbStatus");
            setUpdateHbFromHub(message);
        });

        connection.start();
        return connection;
    }

    const nebosvodLogin = useCallback((nebosvodLogin) => {
        setIsNebosvodAuth(true)
        setNebosvodLogin(nebosvodLogin)
        logger.info("nebosvod login: " + nebosvodLogin)
    }, []);

    const modemCardClick = useCallback((imei) => {
        const selected = drones.find(d => d.imei === imei);
        if (selected) {
          setIsBind(false); 
          setDrone(selected);
          setMapFocusOnDrone({});
        }
      }, [drones]);
    
    const markerClick = useCallback((imei) => {
        const selected = drones.find(d => d.imei === imei);
        if (selected) {
          setIsBind(false); 
          setDrone(selected);
          scrollToModemCard(imei);
        }
    }, [drones]);

    const scrollToModemCard = (imei) => {
        const el = modemCardRefs.current[imei];
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      };

    const callback = (id, phase, actualTime, baseTime, startTime, commitTime) => {
        logger.info(`${id}'s ${phase} phase: Actual: ${actualTime} ms`);
    }

    return(
        <>
            { drone == null ? <ConsoleNavMenu drone={null} /> : <ConsoleNavMenu drone={drone} toggleShowMenu={toggleShowMenu} showMsgsAct={consoleNavMsgClick} startMsgs={startMsgs}/>}
            <SubscriptionNotification subscriptions={subscriptions}/>
            { mode === "fpv" ? <Fpv drone={drone}/> : <></>}
            <div className='console-blocks'>
                <div className='console-drones'>
                    <ConsoleMap currentDrone={drone} udpateFocus={mapFocusOnDrone} markerClick={markerClick}/>
                    <div className='console-modem-cards'>
                        {/*drones.length > 4 ? <SortCard onlineTopClick={() => { onlineTopClick() }} /> : <></>*/}
                        {modemCardOnlineTop ?
                            drones.sort((x, y) => x.name.localeCompare(y.name, "pl")).sort(x => x.isOnline ? -1 : 1).map(d => 
                                <div key={d.imei} ref={el => modemCardRefs.current[d.imei] = el}>
                                    <ModemCard 
                                        imei={d.imei}
                                        modemName={d.name}
                                        isOnline={d.isOnline}
                                        isActive={drone?.imei === d.imei}
                                        version={d.version}
                                        update={d.isLastFirmware}
                                        upgrade={d.upgradable}
                                        isArm={d.isArm}
                                        mavType={d.mavType}
                                        onClick={modemCardClick}
                                    />
                                </div>) 
                            : 
                            drones.map(d => 
                                <div key={d.imei} ref={el => modemCardRefs.current[d.imei] = el}>
                                    <ModemCard 
                                        imei={d.imei}
                                        modemName={d.name}
                                        isOnline={d.isOnline}
                                        isActive={drone?.imei === d.imei}
                                        version={d.version}
                                        update={d.isLastFirmware}
                                        upgrade={d.upgradable}
                                        isArm={d.isArm}
                                        mavType={d.mavType}
                                        onClick={modemCardClick}
                                    />
                                </div>)
                        }
                        { isAstra ? <></> : <ConsoleBindCard onClick={() => {setIsBind(true); setDrone(null);}}/>}
                    </div>

                    <StatusText drone={drone} showMsgs={showMsgs} startMsgs={startMsgs} />
                    <WebRtc drone={drone} mode={mode}/>
                    <NavigationData drone={drone}/>
                    <FpvModeButton drone={drone} click={() => {setShowFpvModel(true)}}/>

                    <Modal  show={showFpvModal} onHide={() => {setShowFpvModel(false)}}>
                        <Modal.Header closeButton>
                        <Modal.Title style={{color: "black"}}>Осторожно</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{color: "black"}}>При переходе в FPV режим, вы перехватите управление, если уже кто-то подключен через Astra</Modal.Body>
                        <Modal.Footer>
                        <Button variant="secondary" onClick={() => {setShowFpvModel(false)}}>
                            {/*t('close')*/}Закрыть
                        </Button>
                        <Button variant="primary" onClick={() => {setMode('fpv'); setShowFpvModel(false);}}>
                            {/*t('continue')*/} Продолжить
                        </Button>
                        </Modal.Footer>
                    </Modal>

                    {isLoad ? 
                    <>
                        {isBind | (drone == null || drone.imei == null) ? 
                            <> { isAstra ? <AstraWelcome droneCount={drones.length} /> : <ConsoleBind/>} </>
                            : <></>
                        }
                        
                    </>
                    :
                    <>
                    </>
                    }
                </div>
            </div>
            {isLoad ? 
                <>
                    {isBind | (drone == null || drone.imei == null) ? <></>
                        : 
                        <Offcanvas show={showMenu} onHide={handleCloseMenu} name="test name" placement='end'>
                            <Offcanvas.Body>
                                <ModemSettings drone={drone} isNebosvodAuth={isNebosvodAuth} nebosvodAuthLogin={nebosvodAuthLogin} onNebosvodAuth={nebosvodLogin} isAstra={isAstra}/>
                            </Offcanvas.Body>
                        </Offcanvas>
                    }
                </> : <></>
            }
        </>
    )
}
    

export default Console;
